import React from 'react';

import { useParams } from 'react-router-dom';
import { CREATE_STUDENT_RECORD_UNAVAILABLE, registerHelperText } from './lang';
import { useGetStudentParticular } from '../../../graphql';

type CreateStudentRecordProp = {
  refetchApplicationNum: () => void;
  handleJumpNext: () => void;
};

/**
 * This component is a temporary placeholder of CreateStudentRecord component
 * as the system is not ready.
 *
 * Props are kept to avoid any import warnings in its parent component.
 */
export const CreateStudentRecordUnavailable: React.FC<
  CreateStudentRecordProp
> = props => {
  const { applicationId = '' } = useParams();
  const { studentParticular } = useGetStudentParticular(applicationId);

  const { offeredToYear, offeredToSemester } = studentParticular;

  const convertEntryYearMap: Record<string, string> = {
    '2023-03': '30/04/2024',
    '2024-01': '31/08/2024',
    '2024-02': '31/12/2024',
    '2024-03': '30/04/2025',
    '2025-01': '31/08/2025',
  };

  return (
    <div>
      <div
        className="px-2 py-4 mr-2"
        dangerouslySetInnerHTML={{
          __html: registerHelperText(
            convertEntryYearMap[offeredToYear + '-' + offeredToSemester],
          ),
        }}
      />
      <div
        className="px-2 py-4 mr-2"
        dangerouslySetInnerHTML={{
          __html: CREATE_STUDENT_RECORD_UNAVAILABLE,
        }}
      />
    </div>
  );
};
